import useApi from 'hooks/useApi'
import { useQuery } from '@tanstack/react-query'

const useGetSuggestionsSeries = () => {

  const { apiFetch } = useApi();
  const url = `/suggestions/series/unfinished`

  const getSuggestions = () => {
    return apiFetch({ url })
      .then(res => {
        const data = res.data.map(({ serie }) => (
          { ...serie, to:`series/${serie.uuid}` }
        ))
        return data
      })
  }

  const options = {
    staleTime: 60000 * 30 // 30 min
  }

  return useQuery(['user', 'suggestions_series'], getSuggestions, options)
}

export default useGetSuggestionsSeries
